import { gql } from '@apollo/client';

export const CREATE_CREW_MEMBER_ABSENCE = gql`
	mutation createCrewMemberAbsence(
		$input: CrewMemberAbsenceInput!
		$overlappingActivityAction: OverlappingActivityAction
	) {
		createCrewMemberAbsence(input: $input, overlappingActivityAction: $overlappingActivityAction) {
			... on CrewMemberAbsenceConflictingWorkAssignmentsResponse {
				__typename
			}
			... on CrewMemberAbsenceSuccessResponse {
				__typename
				absence {
					id
					fromTimestamp
				}
			}
			... on CrewMemberAbsenceErrorResponse {
				__typename
				errors
			}
			... on CrewMemberAbsenceOverlappingActivitiesResponse {
				__typename
				overlappingActivities {
					fromTimestamp
					toTimestamp
					isCancellable
					activity {
						... on CrewMemberWorkAssignmentActivityItem {
							title
							rideId
							deadheadId
							activityType
							status
							fromStation {
								id
								name
								code
								timezone
							}
							toStation {
								id
								name
								code
								timezone
							}
							note
						}
						... on CrewMemberAbsenceActivityItem {
							reason {
								id
								name
							}
							note
						}
					}
				}
			}
		}
	}
`;
